import React from "react";
import "./ui.scss";

const Spinner: React.FC = () => <span className="spinner" aria-label="loading" />;

export default Spinner;


